var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeRel3B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 47C36.9787 47 47.5 36.4787 47.5 23.5C47.5 10.5213 36.9787 0 24 0C11.0213 0 0.5 10.5213 0.5 23.5C0.5 36.4787 11.0213 47 24 47Z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 13C18.2103 13 13.5 17.7103 13.5 23.5C13.5 29.2897 18.2103 34 24 34C29.7897 34 34.5 29.2897 34.5 23.5C34.5 17.7103 29.7897 13 24 13ZM15.6 23.5C15.6 21.5617 16.2657 19.7809 17.3724 18.3581L29.1418 30.1276C27.674 31.2761 25.8638 31.9001 24 31.9C19.3684 31.9 15.6 28.1315 15.6 23.5ZM30.6276 28.6418L18.8581 16.8724C20.3261 15.724 22.1362 15.1001 24 15.1C28.6315 15.1 32.4 18.8684 32.4 23.5C32.3995 25.3637 31.7756 27.1737 30.6276 28.6418Z",
    fill: "#339C89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeRel3B);
export default __webpack_public_path__ + "static/media/icone-rel-3B.0d3d3497bc2e88785f31e2ea69daeda4.svg";
export { ForwardRef as ReactComponent };